import { useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Modal, Row, Table, Form, InputGroup } from 'react-bootstrap';
import ErrorModal from './common/errorModal';
import useApi from '../utilities/useApi';
import arrayUtilities from '../utilities/arrayUtilities';
import stringUtilities from '../utilities/stringUtilities';
import FilterBar from './common/filterBar';
import Loading from './common/loading';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import roleUtilities from '../utilities/roleUtilities';

export default function Organisations() {

    const { api } = useApi();
    const navigate = useNavigate();
    const [filter, setFilter] = useState("");
    const [filteredOrganisations, setFilteredOrganisations] = useState(null);
    const [user, setUser] = useState(null);
    const [organisationalUnits, setOrganisationalUnits] = useState(null);
    const [includeDeleted, setIncludeDeleted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [deleteModal, setDeleteModal] = useState(null);
    const [isPermanentDelete, setIsPermanentDelete] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [errorModal, setErrorModal] = useState(null);
    const [shardInfoModal, setShardInfoModal] = useState(null);

    const fetchOrganisationalUnits = (showDeleted) => {
        api.getOrganisationalUnits(showDeleted, (data) => setOrganisationalUnits(data), error => console.log(error))
    }

    const closeDeleteModal = () => {
        setDeleteModal(null);
        setIsPermanentDelete(false);
        setIsDeleting(false);
    }

    const softDeleteOrg = (org) => {
        setIsDeleting(true);
        api.deleteOrganisationalUnit(org.id, () => {
            closeDeleteModal();
            if (includeDeleted) {
                setOrganisationalUnits(prev => prev.map(o => o.id === org.id ? { ...o, deleted: true } : o));
            } else {
                setOrganisationalUnits(prev => prev.filter(o => o.id !== org.id));
            }
        }, (error) => {
            setIsDeleting(false);
            closeDeleteModal();
            setErrorModal({ message: error?.message || 'An error occurred. Please try again.' });
        });
    }

    const permanentlyDeleteOrg = (org) => {
        setIsDeleting(true);
        api.permanentlyDeleteOrganisationalUnit(org.id, (data) => {
            closeDeleteModal();
            setOrganisationalUnits(prev => prev.filter(o => o.id !== org.id));
            if (data?.shardDatabase) {
                setShardInfoModal({ database: data.shardDatabase, server: data.shardServer });
            }
        }, (error) => {
            setIsDeleting(false);
            closeDeleteModal();
            setErrorModal({ message: error?.message || 'An error occurred. Please try again.' });
        });
    }

    const refreshUser = function () {
        api.getUser((data) => {
            setUser(data);
            setIsLoading(false);
            fetchOrganisationalUnits(includeDeleted)
        }, () => {
            setUser(null);
            setIsLoading(false);
        });
    }

    useEffect(() => {
        refreshUser();
    }, [])

    useEffect(() => {
        setFilteredOrganisations(arrayUtilities.isNullOrEmpty(organisationalUnits) ? [] : organisationalUnits.filter((o) => {
            return stringUtilities.isNullOrEmpty(filter) ||
                o.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
                o.id.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
                organisationalUnits.filter(x => x.leftEdge > o.leftEdge && x.rightEdge < o.rightEdge && x.depth > o.depth && x.name.toLowerCase().indexOf(filter.toLocaleLowerCase()) > -1).length > 0 ||
                organisationalUnits.filter(x => x.leftEdge > o.leftEdge && x.rightEdge < o.rightEdge && x.depth > o.depth && x.id.toLowerCase().indexOf(filter.toLocaleLowerCase()) > -1).length > 0;
        }));
    }, [filter, organisationalUnits]);

    const isGlobalAdmin = user && roleUtilities.isGlobalAdmin(user);

    return (<>
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2 report user-activity-report'>
            <Row>
                <Col className='mb-5'>
                    <div className='d-flex justify-content-between my-5'>
                        <h1 className="h2 m-0">Organisations</h1>
                        <div className="d-flex align-items-start">
                            <Form.Group className='d-flex mt-1'>
                                <div className="d-flex align-items-center">
                                    <Form.Label className='text-body fs-sm mb-0 pe-1 text-nowrap'>Include deleted</Form.Label>
                                    <InputGroup size="sm">
                                        <Form.Check type='switch' id="include-deleted" className="me-2 mt-2" checked={ includeDeleted } onChange={ e => {
                                            setIncludeDeleted(e.target.checked);
                                            fetchOrganisationalUnits(e.target.checked)
                                        } } />
                                    </InputGroup>
                                </div>
                            </Form.Group>
                            <FilterBar value={ filter } onChange={ setFilter } className="mb-4" />
                            {user && roleUtilities.hasOrgAdminCapability(user) && <Button size="sm" className="ms-2 text-nowrap" onClick={ () => navigate("/organisations/add") }>
                                <span className='d-flex align-items-center'><i className='fi-plus me-2'></i>
                                    Add Organisation</span></Button>}
                        </div>
                    </div>
                    {
                        isLoading
                            ? <Loading />
                            : <Table responsive hove sm>
                                <thead>
                                    <tr>
                                        <th className="text-left" style={ { paddingLeft: "0" } }>Name</th>
                                        <th className="text-center">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody className="organisation-table">
                                    {
                                        !arrayUtilities.isNullOrEmpty(filteredOrganisations) && filteredOrganisations
                                            .map((org, index) =>
                                                <tr className="align-middle" key={ org.id } index={ index }>
                                                    <td key={ `organisation-selector-${ org.id }` } className={ `org-name organisation-level-${ org.depth - filteredOrganisations[0].depth }` }>
                                                        <>
                                                        {
                                                            index > 0 && org.depth > filteredOrganisations[index - 1].depth &&
                                                            <><i className={`fi-corner-down-right indent-icon-${org.depth - filteredOrganisations[0].depth}`}></i></>
                                                        }
                                                        <span className={`btn-link ${org.deleted && "text-muted"}`}>{ org.name }</span>
                                                        </>
                                                    </td>

                                                    <td className="text-end">
                                                        {(!org.deleted || isGlobalAdmin) && <Dropdown>
                                                            <Dropdown.Toggle className='bg-none btn-secondary organisation-options-dropdown-toggle'><i className='fi-dots-vertical'></i></Dropdown.Toggle>
                                                            <Dropdown.Menu align='end' className='my-1'>
                                                                {!org.deleted && <>
                                                                    {isGlobalAdmin && <Dropdown.Item onClick={ () => navigate(`/organisations/${org.id}/edit`) }>Edit</Dropdown.Item>}
                                                                    <Dropdown.Item onClick={() => navigate(`/organisations/${org.id}/api-keys`)} eventKey='2'>API Keys</Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                </>}
                                                                <Dropdown.Item className="text-danger" onClick={() => { setDeleteModal(org); setIsPermanentDelete(org.deleted); }}>
                                                                    {org.deleted ? "Permanently Delete" : "Delete"}
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>}
                                                    </td>
                                                </tr>)
                                    }
                                </tbody>
                            </Table>
                    }
                </Col>
            </Row>
        </Container>

        {deleteModal &&
            <Modal show onHide={closeDeleteModal} centered>
                <Modal.Header>
                    <Modal.Title>Delete Organisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isPermanentDelete
                        ? <>
                            <Alert variant="danger">
                                <i className="fi-alert-circle me-2"></i>
                                This action is irreversible. <strong>{deleteModal.name}</strong> will be permanently removed and cannot be recovered.
                            </Alert>
                            {deleteModal.shardId &&
                                <p className="mb-3 text-muted fs-sm">This organisation has an associated shard. Its mapping will be de-registered and the database can be dropped after deletion.</p>
                            }
                          </>
                        : <p>Are you sure you want to delete <strong>{deleteModal.name}</strong>?</p>
                    }
                    {isGlobalAdmin && !deleteModal.deleted &&
                        <Form.Check
                            type="switch"
                            id="permanent-delete-toggle"
                            label="Permanently delete"
                            checked={isPermanentDelete}
                            onChange={e => setIsPermanentDelete(e.target.checked)}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="secondary" onClick={closeDeleteModal} disabled={isDeleting}>Cancel</Button>
                    <Button size="sm" variant={isPermanentDelete ? "danger" : "primary"} disabled={isDeleting}
                            onClick={() => isPermanentDelete ? permanentlyDeleteOrg(deleteModal) : softDeleteOrg(deleteModal)}>
                        {isDeleting
                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Deleting…</>
                            : isPermanentDelete ? "Permanently Delete" : "Delete"
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        }

        {shardInfoModal &&
            <Modal show onHide={() => setShardInfoModal(null)} centered>
                <Modal.Header>
                    <Modal.Title>Organisation Deleted</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The organisation has been permanently deleted.</p>
                    <p className="mb-1">The following shard database has been de-registered and can now be safely dropped:</p>
                    <Alert variant="info" className="mb-0">
                        <div><strong>Database:</strong> {shardInfoModal.database}</div>
                        <div><strong>Server:</strong> {shardInfoModal.server}</div>
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="primary" onClick={() => setShardInfoModal(null)}>OK</Button>
                </Modal.Footer>
            </Modal>
        }

        {errorModal && <ErrorModal error={errorModal} onDismiss={() => setErrorModal(null)} />}
    </>)
}
